import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/styles/userPartnerItemReg.module.scss';
//compWrapper
import Section from 'src/webapp/views/wrapper/Section';
import Container from 'src/webapp/views/wrapper/Container';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
//hook
import usePartnerHook from 'src/webapp/hooks/partner/partner.hook';
//comp
import Menu from 'src/webapp/views/component/Menu';//메뉴
import Titlebar from 'src/webapp/views/component/Titlebar';//상단타이틀
import Form from './child/Form';//입력폼
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function PartnerItemUpdate() {
    const location = useLocation();//location
    //hook
    const { vehiclePriceGroupListAPI, priceGroupList } = usePartnerHook();
    /* ============================ 하위컴포넌트 데이터리셋 ============================ */
    const [ clear,setClear ] = useState(0);
    const onClearHandler = () => {
        setClear(clear + 1);
    }
    /* ============================ 하위컴포넌트 데이터리셋 ============================ */
    /* ==================== 하위컴포넌트 수정하기 ==================== */
    //하위컴포넌트ref
    const childRef = useRef({});
    //수정하기핸들러
    const onSubmitHandler = () => {
        childRef.current.onSubmitHandler();
    }
    /* ==================== 하위컴포넌트 수정하기 ==================== */
    
    useEffect(() => {
        vehiclePriceGroupListAPI();
    }, [])

    class PartnerItemUpdate extends React.Component {
        state = { isDisabled:true };
        handleChange = (e, value) => { 
            //this.setState({  ...this.state, index:value }); 
            this.setState({ isDisabled:true }); 
        };
        onValidHandler = (item, value) => {
            if(this.state.isDisabled != value) {
                this.setState({...this.state, isDisabled:value });
            }
        };
        render() { const { isDisabled } = this.state;

    return ( 
        <>
        <Section>
            <Menu />{/* 메뉴 */}
            <Container>
                <FixedPanel>
                    <Titlebar title={`차량 등록`} dept={[{ label: '회원관리' }, { label: '파트너스' }, { label: '파트너 정보' }, { label: '상품 수정' }]} />{/* 상단타이틀 */}
                </FixedPanel>
                <FlickPanel className={styles.formContainer}>
                    <Form type={2} data={location.state} ref={childRef} onClear={onClearHandler} priceGroupList={priceGroupList} onValid={this.onValidHandler} />
                    <Element tag={`div`} className={styles.btnArea}>
                        <Link to={-1}><FontAwesomeIcon icon="fa-light fa-chevron-left" /><Element tag={`span`}>이전으로</Element></Link>
                        <button onClick={(e) => onSubmitHandler()} disabled={isDisabled}><FontAwesomeIcon icon="fa-light fa-paper-plane-top" /><span>수정하기</span></button>
                    </Element>
                </FlickPanel>
            </Container>
        </Section>
        </>
        )}
    } return ( <PartnerItemUpdate /> )
}